import { overArgs } from "lodash";
import { generateUUID } from "utils/appUtil";
export const getItemListRequestPayload = (
  paths: string[],
  returnPath: string = "$",
  pagination: IPagination = { offset: 0, limit: 200 },
  searchArguments: object = undefined
): IPublishRequest => {
  const payload: IListRequest = {
    paths,
    returnPaths: [returnPath],
    pagination: pagination,
    ...searchArguments,
  };
  return payload;
};

export const updateItemRequestPayload = (
  id: number,
  op: RequestOperation,
  path: string,
  data: any
): ICreateOrUpdateRequest => {
  return {
    objectId: id,
    operation: op,
    path,
    value: data,
  };
};

export const getMessageRef = (
  referenceType: MessageReferenceType,
  pageMessageId: string
): IReferenceType => {
  return {
    referenceType,
    pageMessageId,
  };
};

export const getRequestHeader = (
  connectionId: string,
  rootUserId: string
): IHeader => {
  return {
    accessToken: "",
    connectionId: connectionId,
    userId: rootUserId,
    udid: generateUUID(),
  };
};

export const getMessageRequestPayload = (
  connectionId: string,
  rootUserId: string,
  pageId: number,
  connectionPubTopic: string,
  type: string,
  attributes: any,
  originalCreatedAt?: number,
  refMessage: IReferenceType | undefined = undefined,
  originalPageMessageId: string | undefined = undefined,
  notificationTypes: any = []
): IMessage => {
  let date = new Date().getTime();
  return {
    header: {
      ...getRequestHeader(connectionId, rootUserId),
    },
    messages: [
      {
        message: {
          type: type,
          attributes: attributes,
        },
        connectionInfo: {
          connectionMessageId: generateUUID(),
          connectionId: connectionId,
          pageId: pageId,
          userId: rootUserId,
          createdAt: date,
          originalCreatedAt: originalCreatedAt ? originalCreatedAt : date,
          refMessage,
          originalPageMessageId,
          notificationTypes,
        },
      },
    ],
    connectionId: connectionId,
    connectionPubTopic: connectionPubTopic,
  };
};

export const wrapRequestPayload = (
  payload: IPublishRequest | any,
  id?: string
): IPublishWrapRequest => {
  return {
    id: id || generateUUID(),
    data: {
      ...payload,
    },
  };
};

export const getPageSearchArgument = (search?: string, args?: any, projects?: any): any => {
  let index = "pageUpdatedAtIndex";
  let filterArg = "";
  let load: any = {
    pageId: "$.objectId",
    objectStatus: "$.objectStatus",
    persistent: "$.persistent",
    nonpersistent: "$.nonpersistent",
    title: "$.persistent.static.metadata.title",
    createdAt: "$.persistent.static.metadata.createdAt",
    updatedAt: "$.nonpersistent.dynamic.metadata.lastSent.members.updatedAt",
    activeIot: "$.nonpersistent.static.live.activeIot..userId",
    status: "$.nonpersistent.static.live.status.name"
  };
  let expressionBuffer = [];
  let sortByProperties = [];

  if (search && search !== "") {
    expressionBuffer.push(
      `(exists(@title) && contains(lower(@title),lower('${search}')) || (exists(@pageId) && contains(lower(@pageId),lower('${search}'))))`
    );
  }

  const filter = JSON.parse(localStorage.getItem("filter"));
  if (filter) {
    const {
      readStatus,
      pageType,
      pageStatus,
      userStatus,
      deleted,
      createdAt,
      sort,
      order,
      owner,
      liveIoT,
    } = filter;
    let sortByOptions = {
      title: {
        field: "@title",
        order: (order ?? "asc").toUpperCase(),
      },
      createdAt: {
        field: "@createdAt",
        order: (order ?? "desc").toUpperCase(),
      },
      updatedAt: {
        field: "@updatedAt",
        order: (order ?? "desc").toUpperCase(),
      },
    };
    if (readStatus.length === 1) {
      if (readStatus[0] === "Read")
        filterArg += `-(@unreadUsers:{${localStorage.getItem("RID")}})`;
      else filterArg += `@unreadUsers:{${localStorage.getItem("RID")}}`;
    }
    if (pageType !== "all") {
      filterArg += `@pageType:{${pageType}}`;
    }
    if (userStatus) {
      filterArg += `@statusUser:{${userStatus}*}`;
    }
    if (pageStatus) {
      expressionBuffer.push(`exists(@status) && @status==='${pageStatus}'`);
    }
    if (liveIoT.indexOf("Video") !== -1) {
      load.activeCall = "$.nonpersistent.dynamic.live.activeCall.roomId";
      expressionBuffer.push("exists(@activeCall)");
    }
    if (liveIoT.indexOf("GPS") !== -1) {
      load.activeGps =
        "$.nonpersistent.static.live.activeIot..iotUdid";
      expressionBuffer.push("exists(@activeGps)");
    }
    if (owner && owner !== "") {
      filterArg += `@pageMembers:{${owner}}`;
      load.ownerRoleCheck = `$.persistent.static.metadata.members.users.${owner}.role`;
      expressionBuffer.push(
        "exists(@ownerRoleCheck) && @ownerRoleCheck=='edit'"
      );
    }
    filterArg += `@objectStatus:{${deleted ? "deleted" : "active"}}`;
    if (createdAt) {
      let date = new Date(createdAt);
      filterArg += `@createdAt:[${date.setHours(
        0,
        0,
        0,
        0
      )},+inf]@createdAt: [-inf,${date.setHours(23, 59, 59, 999)}]`;
    }
    if (sort === "Page created") {
      sortByProperties.push(sortByOptions.createdAt);
      sortByProperties.push(sortByOptions.updatedAt);
    } else if (sort === "Last updated") {
      index = "pageUpdatedAtIndex";
      sortByProperties.push(sortByOptions.updatedAt);
      sortByProperties.push(sortByOptions.createdAt);
    } else if (sort === "Title") {
      sortByProperties.push(sortByOptions.title);
    } else if (
      sort === "Read/Unread" &&
      (!readStatus || readStatus.length === 0 || readStatus.length === 2)
    ) {
      let read = order === "ASC";
      if (args?.read !== undefined) read = args.read;
      if (read) {
        filterArg += `-(@unreadUsers:{${localStorage.getItem("RID")}})`;
      } else {
        filterArg += `@unreadUsers:{${localStorage.getItem("RID")}}`;
      }
    } else if (sort === "Relevance") {
      index = "pageInvitedIndex";
      let relevance = order === "ASC";
      if (args?.pending !== undefined) relevance = args.pending;
      if (relevance) {
        filterArg += `pendingMembers:{${localStorage.getItem("RID")}})`;
      } else {
        filterArg += `-(@pendingMembers:{${localStorage.getItem("RID")}})`;
      }
    }
  }
  return {
    searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:${index}`,
    searchQuery: `@pageMembers:{${localStorage.getItem("RID")}${(projects?.adminUserId && (projects?.permissions?.indexOf("admin") !== -1 || projects?.permissions?.indexOf("cad") !== -1)) ? `|${projects?.adminUserId}` : ""}}${filterArg}`,
    load,
    sortByProperties:
      sortByProperties.length > 0
        ? sortByProperties
        : [
          {
            field: "@updatedAt",
            order: "DESC",
          },
        ],
    filterExpression: expressionBuffer.join(" && "),
  };
};
